import { SET_SHOW } from "../actions/constantes";

const setShow = (payload) => {
    return{
        type: SET_SHOW,
        payload
    }
};

export default setShow;